<template>
  <v-container fluid>
    <SomeComponent />
    <a
      href="https://www.iubenda.com/privacy-policy/56862819"
      class="iubenda-white no-brand iubenda-embed iub-body-embed"
      title="Privacy Policy"
    ></a>
  </v-container>
</template>

<script>
export default {
  components: {
    SomeComponent: () => {
      (function(w, d) {
        console.log(w, d);
        var loader = function() {
          var s = d.createElement("script"),
            tag = d.getElementsByTagName("script")[0];
          s.src = "https://cdn.iubenda.com/iubenda.js";
          tag.parentNode.insertBefore(s, tag);
        };
        if (w.addEventListener) {
          w.addEventListener("load", loader, false);
        } else if (w.attachEvent) {
          w.attachEvent("onload", loader);
        } else {
          w.onload = loader;
        }
      })(window, document);
    }
  }
};
</script>